import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import './sortableItem.css';

const SortableItem = (props) => {
  return (<li><div className='dropBox' style={{marginTop:props.ind==0?"15px":"0px",marginBottom:props.ind==4?"15px":"0px"}}><input type='checkbox' className="graph-input" checked={props.value.visible} onChange={()=>{props.checkGraph(props.ind)}}></input>{props.value.graph}</div></li>);
};

export default SortableElement(SortableItem);
